module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-723-retro.453ef38f.jpg";